module.exports = __webpack_public_path__ + "gb-sct.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gb-sct.svg
// module id = 906
// module chunks = 0